import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import LinearProgress from '@mui/material/LinearProgress';

const styles = {
  progress: {
    width: '100%',
  }
};

class ProgressToolbar extends React.Component {

  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <Toolbar>
        <LinearProgress color="secondary" sx={styles.progress}/>
      </Toolbar>
    );
  }
}

export default ProgressToolbar;
